<!--
 * @Author: wangliang
 * @LastEditTime: 2024-03-12 10:28:33
 * @Description: 模型库树
-->
<template>
  <div>
    <el-dialog
      class="mini-dialog"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="modelTreeProps.visible"
      :title="modelTreeProps.title"
      :close-on-click-modal="false"
      @close="close(false)"
    >
      <el-form
        :model="modelTreeContextForm"
        :rules="modelTreeFormRules"
        ref="modelTreeForm"
        label-width="150px"
        :disabled="modelTreeProps.editType === 'read'"
      >
        <el-form-item label="文件夹名称" prop="name">
          <el-input
            v-model="modelTreeContextForm.name"
            :type="modelTreeProps.editType === 'create' ? 'textarea' : 'text'"
            :nums="3"
            :autosize="{ minRows: 3, maxRows: 10 }"
            :placeholder="
              modelTreeProps.editType === 'create'
                ? '系统支持批量添加文件夹，每一行为一个文件夹'
                : '文件夹名称'
            "
            size="small"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="文件夹路径"
          prop="directoryId"
          v-if="modelTreeProps.editType === 'edit'"
        >
          <el-select
            ref="modelTree"
            v-model="modelTreeContextForm.path"
            popper-class="model-select-tree"
            :popper-append-to-body="false"
            :placeholder="`请选择文件夹路径`"
            filterable
          >
            <el-option :label="modelTreeContextForm.path" :value="modelTreeContextForm.path">
              <el-tree
                :props="{
                  children: 'childrens',
                  label: 'name',
                }"
                node-key="id"
                highlight-current
                @node-click="treeNodeClick"
                :expand-on-click-node="false"
                :load="loadTreeData"
                lazy
              ></el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center" v-if="modelTreeProps.editType !== 'read'">
        <el-button size="small" type="primary" @click="save()" :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" @click="close(false)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash'
import ModelServer from '../services/modelServer'

export default {
  name: 'operateModelTreeDialog',
  props: {
    moduleConfig: {
      type: Object,
      default: () => {
        return {}
      },
    },
    modelTreeProps: {
      type: Object,
      default: () => {
        return {
          visible: true,
          title: '新增文件夹',
          editType: 'create',
        }
      },
    },
    modelTreeForm: {
      type: Object,
      default: () => {
        return {
          name: '',
        }
      },
    },
    // 弹框信息
    pageInfo: {
      type: Object,
      default: () => {
        return {
          standardId: '',
          parentId: '',
        }
      },
    },
  },
  data() {
    return {
      modelTreeContextForm: {
        name: '', // 文件夹名称
        path: '', // 文件夹路径
      },
      // 表单保存状态
      saveLoading: false,
      // 请求实例
      requestInstance: null,
    }
  },
  computed: {
    modelTreeFormRules() {
      return {
        name: [
          {
            required: true,
            message: '请输入文件夹名称',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  methods: {
    /**
     * @description 目录树懒加载
     */
    async loadTreeData(node, resolve) {
      this.treeLoading = true
      const res = await ModelServer.getTreeNodes({
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        filter: '', // 文档目录名称(模糊查询)
        isRoot: node.level === 0, // 是否是根节点
        nodeId: node?.data?.id, // 当前节点id
      })
      this.treeLoading = false
      if (res && res.data && res.code === 0) {
        resolve(res.data)
        return
      }
      resolve([])
    },

    // 目录树节点点击
    treeNodeClick(node) {
      this.modelTreeContextForm.path = node.path
      this.$refs.modelTree.blur()
    },

    close(isRefresh) {
      this.$emit('closeModelTreeDialog', isRefresh)
    },
    save() {
      this.$refs.modelTreeForm.validate(async (valid) => {
        if (!valid) return
        if (this.modelTreeProps.editType === 'create') {
          const pageName = this.modelTreeContextForm.name
          const pageNameList = pageName.split(/\n/)
          for (let i = 0; i < pageNameList.length; i += 1) {
            if (pageNameList[i] === pageNameList[i + 1]) {
              this.$message({
                type: 'warning',
                message: '树节点名称不能相同,请重新输入',
                duration: 2000,
              })
              return
            }
            if (pageNameList[i] === '') {
              pageNameList.splice(i, 1)
            }
          }
          this.saveLoading = true
          const params = _.map(pageNameList, (i) => {
            return {
              name: i,
              parentId: this.pageInfo.parentId
                ? this.pageInfo.parentId
                : '00000000-0000-0000-0000-000000000000',
              standardId: this.pageInfo.standardId,
            }
          })
          const res = await ModelServer.addTreeNode(params)
          this.saveLoading = false
          if (res?.code === 0) {
            this.$message({
              type: 'success',
              message: '成功',
              duration: 2000,
            })
            this.close(true)
          }
          return
        }

        this.saveLoading = true
        const putRes = await ModelServer.putTreeNode({
          id: this.modelTreeContextForm.id,
          name: this.modelTreeContextForm.name,
          parentId: this.modelTreeContextForm.parentId,
          path: this.modelTreeContextForm.path,
        })
        this.saveLoading = false
        if (putRes?.code === 0) {
          this.$message({
            type: 'success',
            message: '成功',
            duration: 2000,
          })
          this.close(true)
        }
      })
    },
  },
  created() {
    this.modelTreeContextForm = cloneDeep(this.modelTreeForm)
  },
}
</script>

<style lang="scss">

.model-select-tree .el-select-dropdown__item {
  height: unset !important;
  line-height: unset !important;
  background: transparent !important;
}

.model-select-tree .el-tree-node__label {
  color: #000 !important;
}

</style>
